import {
  Badge,
  Button,
  GroupTextField,
  Icon,
  Input,
  TextField,
} from "@elaniintc/goes-design-system";
import { useState, type ComponentProps } from "react";
import { useEntity } from "../context";
import { cn } from "@/utils/theme";
import { OWNER_ROLE_ID } from "../../types";
import { getRoleBadgeColor, getRoleBadgeLabel } from "../../utils";

export const RolesList = ({
  label,
  placeholder,
  required,
}: ComponentProps<typeof TextField>) => {
  const [configSelectNewItem, setConfigSelectNewItem] = useState<string>("");
  const [roleError, setRoleError] = useState<string | undefined>(undefined);
  const { rolesList, addRole, removeRole } = useEntity();

  const handleAddSelectItem = () => {
    const v = configSelectNewItem.trim();

    if (!v) {
      setRoleError("El rol es no puede estar vacío");
      return;
    }

    const exists = rolesList.some(
      (role) => role.name.trim().toLowerCase() === v.toLowerCase(),
    );

    if (exists) {
      setRoleError("Este rol ya fue existe");
      return;
    }

    addRole(v);
    setConfigSelectNewItem("");
    setRoleError(undefined);
  };

  const handleRemoveSelectItem = (id: string) => {
    removeRole(id);
  };

  return (
    <>
      <div className="flex items-end pt-4">
        <GroupTextField
          className="w-full"
          label={label}
          labelHelperText={required ? undefined : "Opcional"}
          required={required}
          error={roleError}
        >
          <Input
            className="w-full"
            placeholder={placeholder}
            value={configSelectNewItem}
            onChange={(e) => {
              setConfigSelectNewItem(e.target.value);
              if (roleError) {
                setRoleError(undefined);
              }
            }}
          />
          <Button
            className="h-11 rounded-bl-none rounded-tl-none border-l-0"
            variant="quiet"
            onClick={handleAddSelectItem}
          >
            <Icon name="plus" type="far" />
          </Button>
        </GroupTextField>
      </div>

      {rolesList.length > 0 && (
        <div className="w-full rounded-lg border border-neutral bg-neutral-object shadow-sm backdrop-blur px-3 py-2 mt-2">
          <ul className="px-2">
            {rolesList.map((item) => (
              <li
                key={item.id}
                className="flex items-center justify-between py-1"
              >
                <span className="text-base text-body-quiet">{item.name}</span>
                <div className="flex items-center gap-2">
                  <Badge
                    size={"sm"}
                    shape={"pill"}
                    variant={getRoleBadgeColor(item.id)}
                  >
                    {getRoleBadgeLabel(item.id)}
                  </Badge>
                  <Button
                    variant="ghost"
                    size="icon"
                    type="button"
                    aria-label="Eliminar"
                    className={cn(
                      "shrink-0 inline-flex h-9 w-9 items-center justify-center rounded-full text-slate-500 hover:text-slate-700 hover:bg-slate-100 active:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300",
                      item.id === OWNER_ROLE_ID &&
                        "cursor-not-allowed opacity-0 pointer-events-none",
                      item.id === OWNER_ROLE_ID &&
                        rolesList.length === 1 &&
                        "hidden",
                    )}
                    onClick={() => handleRemoveSelectItem(item.id)}
                  >
                    <Icon name="xmark" type="far" />
                  </Button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};
